/** @format */

import BaseManager from './BaseManager';

type Props = {
  buttonVariant?: 'PRIMARY' | 'SECONDARY';
  variant?: 'DARK' | 'LIGHT';
};

const Anna = (props: Props) => {
  const {buttonVariant = 'PRIMARY', variant = 'DARK'} = props;

  return (
    <BaseManager
      buttonVariant={buttonVariant}
      imageSrc={new URL('./images/julia.png', import.meta.url).href}
      name='Anna'
      phone='+48516592350'
      email='mailto:anna.rud@adsensor.io'
      variant={variant}
    />
  );
};

export default Anna;
